import { useState } from 'react'
import { Button } from '../Common/Button'
import { useVisibilityAwareInterval } from '../../hooks/useVisibilityAwareInterval'
import { useNls } from '../../nls/nlsProvider'
import { getAmbientMutes, unmuteAmbientKind } from '../../services/ai/ambient/ambientDismissalStore'
import { AMBIENT_KIND_LABELS } from '../../services/ai/ambient/ambientEvaluatorHeuristics'
import type { AmbientMuteRecord } from '../../services/ai/ambient/ambientTypes'

/**
 * Line ambient-suggestion muting controls. Shipped in Settings so the silent
 * 3-strike mute is discoverable and reversible. Reads live from the local
 * dismissal store; changes take effect on the next evaluator tick.
 */
export const LineSuggestionsPanel = () => {
  const { t } = useNls()
  const [mutes, setMutes] = useState<AmbientMuteRecord[]>([])

  const refresh = () => setMutes(getAmbientMutes())

  useVisibilityAwareInterval(refresh, 5_000, { immediate: true })

  const handleUnmute = (kind: AmbientMuteRecord['kind']) => {
    unmuteAmbientKind(kind)
    refresh()
  }

  return (
    <section className="lineSuggestionsSettings skLineSuggestions">
      {mutes.length === 0 ? (
        <p className="skMuteEmpty">{t('NLSSettingsLineSuggestionsEmpty')}</p>
      ) : (
        <ul className="skMuteList">
          {mutes.map((mute) => (
            <li key={mute.kind} className="skMuteItem">
              <div className="skMuteBody">
                <strong className="skMuteTitle">{AMBIENT_KIND_LABELS[mute.kind]}</strong>
                <small className="skMuteMeta">
                  {t('NLSSettingsLineSuggestionsMutedUntil', { date: new Date(mute.mutedUntil).toLocaleDateString() })} · {mute.reason === 'threshold_dismissals' ? t('NLSSettingsLineSuggestionsReasonDismissals') : t('NLSSettingsLineSuggestionsReasonSettings')}
                </small>
              </div>
              <Button
                variant="primary"
                size="sm"
                onClick={() => handleUnmute(mute.kind)}
              >
                {t('NLSSettingsActionUnmute')}
              </Button>
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
